import { applyAction } from "./appliers";
import type { ShowMeTheCoinAction, ShowMeTheCoinState } from "./types";
import { validateAction } from "./validators";

export interface ReduceResult {
  readonly state: ShowMeTheCoinState;
  readonly accepted: boolean;
  readonly error?: string;
}

// NOTE: does NOT validate — call validateAndReduceGameState at trust boundaries.
export function reduceGameState(
  state: ShowMeTheCoinState,
  action: ShowMeTheCoinAction,
): ShowMeTheCoinState {
  return applyAction(state, action);
}

export function validateAndReduceGameState(
  state: ShowMeTheCoinState,
  action: ShowMeTheCoinAction,
): ReduceResult {
  const validation = validateAction(state, action);
  if (!validation.valid) {
    return { state, accepted: false, error: validation.error };
  }
  return { state: reduceGameState(state, action), accepted: true };
}
